import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Pagination from '../Pagination/index';
import './customTable.scss';
import ModalConfirmation from '../ModalConfirmation';
import { Popup } from 'semantic-ui-react';
import loader from '../../images/loader.gif';
import ActiveIcon from '../../assets/images/Active.png'
import InActiveIcon from '../../assets/images/Inactive.png'
import DraftIcon from '../../assets/images/draftIcon.png'
const PAGESIZE = [{ value: 25, text: '25' }, { value: 50, text: '50' }, { value: 100, text: '100' }];

export default class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paging: props.options.paging,
      sortable: props.options.sortable,
      sortBy: (props.options.defaultSortParams || { sortBy: '' }).sortBy,
      sortOrder: (props.options.defaultSortParams || { sortOrder: 'asc' }).sortOrder,
      pageSize: (props.options.defaultPagingParams || { pageSize: 25 }).pageSize,
      pageIndex: 1,
      originalData: props.data,
      tableData: [],
      pageNeighbours: 1,
      confirmationOpen: false,
      confirmationMessage: '',
      isExpanded: false,
      filterText: '',
      dataLength: props.data.length,
      selectedIds: {},
      selectedheader: false,
      show: false
    };
  }

  componentWillReceiveProps(nextProps, prevProps) {
    if (nextProps.data !== this.props.data) {
      this.setState({
        originalData: nextProps.data,
        pageIndex: this.props.hasOwnProperty('currentIndex') ? this.props.currentIndex : 1,
        selectedIds: {},
        selectedheader: false
      }, () => {
        this.handleCommonMethods();
      });
    }
  }

  // async componentDidMount() {
  //   await this.handleCommonMethods();
  //   this.setState({ pageIndex: 1 });
  // }

  componentDidMount() {
    this.handleCommonMethods();
  }

  sortByFunction = (type, sortBy) => {
    let func;
    switch (type) {
      case 'number-asc':
        func = (a, b) => parseFloat(a[sortBy]) - parseFloat(b[sortBy]);
        break;
      case 'number-desc':
        func = (a, b) => parseFloat(b[sortBy]) - parseFloat(a[sortBy]);
        break;
      case 'string-asc':
        func = (a, b) => {
          if (!a[sortBy] && !b[sortBy]) {
            return 0;
          } else if ((a[sortBy] || '').toLowerCase() < (b[sortBy] || '').toLowerCase()) {
            return -1;
          } else if ((a[sortBy] || '').toLowerCase() > (b[sortBy] || '').toLowerCase()) {
            return 1;
          }
          return 0;
        };
        break;
      case 'string-desc':
        func = (a, b) => {
          if (!a[sortBy] && !b[sortBy]) {
            return 0;
          } else if ((a[sortBy] || '').toLowerCase() < (b[sortBy] || '').toLowerCase()) {
            return 1;
          } else if ((a[sortBy] || '').toLowerCase() > (b[sortBy] || '').toLowerCase()) {
            return -1;
          }
          return 0;
        };
        break;
      case 'date-asc':
        func = (a, b) => new Date(a[sortBy]) - new Date(b[sortBy]);
        break;
      case 'date-desc':
        func = (a, b) => new Date(b[sortBy]) - new Date(a[sortBy]);
        break;
      default:
        func = (a, b) => {
          if (!a[sortBy] && !b[sortBy]) {
            return 0;
          } else if ((a[sortBy] || '').toLowerCase() < (b[sortBy] || '').toLowerCase()) {
            return 1;
          } else if ((a[sortBy] || '').toLowerCase() > (b[sortBy] || '').toLowerCase()) {
            return -1;
          }
          return 0;
        };
    }
    return func;
  };

  filterData = (row, searchColumns, filterText) => {
    return searchColumns.some(a => (a.func && a.func(row) && a.func(row).toString().toLowerCase().indexOf(filterText.toLowerCase()) > -1) || (a.key && row[a.key] && row[a.key].toString().toLowerCase().indexOf(filterText.toLowerCase()) > -1));
    // return searchColumns.some(a => (a.func && a.func(row) && a.func(row).toString().indexOf(filterText) > -1) || (a.key && row[a.key] && row[a.key].toString().indexOf(filterText) > -1));
  };

  // ----- * handleCommonMethods && all records sort (asc, desc) && and add paging * -----
  handleCommonMethods = () => {
    const { originalData, sortable, paging, sortBy, sortOrder, pageIndex, pageSize, filterText } = this.state;
    const { columns, searchable = false, searchColumns = [] } = this.props.options;
    let tableData = originalData;
    let pagingData = _.cloneDeep(originalData);
    let dataLength = tableData.length;

    if (searchable && searchColumns && searchColumns.length && filterText) {
      tableData = originalData.filter(row => this.filterData(row, searchColumns, filterText));
      pagingData = _.cloneDeep(tableData);
      dataLength = tableData.length;
    }

    if (sortable) {
      const column = _.find(columns, (item) => item && item.name === sortBy);
      tableData = tableData.sort(this.sortByFunction(`${(column && column.type) || 'string'}-${sortOrder}`, sortBy));
    }

    if (paging) {
      const offset = ((pageIndex || 1) - 1) * pageSize;
      tableData = tableData.slice(offset, offset + pageSize);
    }

    this.setState({ tableData, pagingData, dataLength });
  };

  // ----- * handlePaging  set value (pageIndex || pageSize) in state && change value Pagination  * -----
  handlePaging = (data) => {
    const { currentPage, pageLimit } = data;

    if (this.props.hasOwnProperty('setCurrentPageIndexForPagination')) {
      this.props.setCurrentPageIndexForPagination(currentPage);
    }
    this.setState({ pageIndex: currentPage, pageSize: pageLimit }, () => {
      this.handleCommonMethods();
    });
  };

  // ----- * handleSorting  set value (sortOrder || sortBy || pageIndex ) in state  * -----
  handleSorting = (column) => {
    const { sortOrder, sortable } = this.state;
    if (!sortable) return;

    this.setState({
      sortOrder: sortOrder === 'asc' ? 'desc' : 'asc',
      sortBy: column.name, pageIndex: 1
    }, () => {
      this.handleCommonMethods();
    });
  };

  // ----- * get Sort Icon (up|down) * -----
  renderSortIcon = (sortOrder) => sortOrder === 'asc' ? <i className="mdi mdi-chevron-up"></i> : <i className="mdi mdi-chevron-down"></i>;

  // ----- * Theader data get  * -----
  renderThead = (options) => {
    const { columns, sortable, actionsThead, actionName, selection } = options;
    const { sortOrder, sortBy, selectedheader } = this.state;
    let data = [];
    columns.forEach((column, index) => {
      column.isDisplay !== false && data.push(<th key={index} scope="col" onClick={column.sortable && sortable ? this.handleSorting.bind(this, column) : null}>{column.label}
        {sortable && column.name === sortBy && this.renderSortIcon(sortOrder)}
      </th>);
    });

    // if (actionsThead && options.actions && options.actions.length) {
    if (selection && selection.show) {
      data.push(<th scope="col">
        <input type="checkbox" name="check" style={{ marginRight: 5 }}
          onChange={this.selectAllCheckBox}
          checked={selectedheader}
        />
        {selection.columnText}
      </th>);
    }
    if (!this.props.hideActionColumn && actionsThead) {
      data.push(<th key={index} scope="col"><center>{actionName ? actionName : "ACTIONS"}</center></th>);
    }
    return data;
  };

  selectAllCheckBox = (event) => {
    let { options: { unique_key }, selectionChange } = this.props;
    const { selectedIds, pagingData, selectedheader } = this.state;
    pagingData.forEach(a => {
      selectedIds[a[unique_key]] = event.target.checked;
    });
    this.setState({ selectedIds, selectedheader: !selectedheader }, () => selectionChange(this.state.selectedIds));
  };

  // ----- * button Click bind single row  * -----
  // actionClick = (row, action, message) => {
  //   if (action.confirmation) {
  //     if (message) { action.confirmationMessage = message };
  //     this.toggleModal({ row, action });
  //     return;
  //   }
  //   this.props.handelAction(row, action)
  // }

  actionClick = (row, action, message = '') => {


    // console.log("action", action, row, message)
    if (action.confirmation) {
      if (message) { action.confirmationMessage = message; };
      this.toggleModal({ row, action });
      return;
    }
    this.props.handelAction(row, action);
  };

  confirmationCallBack = (success, info) => {
    if (success) { this.props.handelAction(info.row, info.action); };
    this.toggleModal();
  };

  toggleModal = (info) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: info });
  };

  renderStatusImage = (key) => {
    switch (key) {
      case 1:
        return <img style={{ objectFit: "contain", marginRight: 5 }} src={ActiveIcon} />;
      case 0:
        return <img style={{ objectFit: "contain", marginRight: 5 }} src={InActiveIcon} />;
      default:
        return <img style={{ objectFit: "contain", marginRight: 5 }} src={DraftIcon} />;
    }
  }

  // ----- * render Button Icon  * -----
  renderActions = (options, row) => {
    let { actions, recActive = false, showSwitch = false, status = {}, rowsSelectiveStatus } = options;
    const { data } = this.props;
    const { key, active, activeIcon, inActiveIcon, draft = -1 } = status;
    const { statusActionDisabled = false } = row;
    if (row.action === false) {
      actions = [];
      recActive = false
      return <td></td>
    } else {
      let actionCols = actions.filter((a) => a.type.toLowerCase() !== 'delete');
      let deleteActionCol = actions.filter((a) => a.type.toLowerCase() === 'delete');
      let deleteOption = (deleteActionCol || []).map((action, actionKey) => (
        <a href="javascript:void(0);" key={actionKey} onClick={this.actionClick.bind(this, row, action, null)} className={`btn btn-outline-primary delete-popup-btn`}>&nbsp;
          {action.icon && <i className={action.icon} />}
          {action.text && <span>{action.text}</span>}
        </a>));
      return (
        <td className={`${row.hasOwnProperty("isErrorPresent") && !row.isErrorPresent ? 'text-left' : 'text-center'} ${row.isErrorPresent ? 'd-flex align-items-center' : ''}`}>
          {/* {(actionCols || []).map((action, actionKey) => (
            <a href="javascript:void(0);" key={actionKey} onClick={this.actionClick.bind(this, row, action, null)} className={`btn ${action.icon === 'mdi mdi-pencil' ? 'text-white btn-primary' : 'btn-outline-primary'} action-pad`}>&nbsp;
              {action.icon && <i className={`${action.icon} ${action.icon === 'mdi mdi-pencil' && 'text-white'}`} />}
              {action.text && <span>{action.text}</span>}
            </a>)
          )} */}

          {recActive && !showSwitch && <a className="btn btn-outline-primary action-pad" onClick={this.actionClick.bind(this, row, status, row[key] == active ? status.activeConfirmationMessage : status.inActiveConfirmationMessage)} >{row[key] == active ? <i className={activeIcon} style={{ fontSize: '14px', color: 'green', paddingLeft: "3px" }} /> : <i className={inActiveIcon} style={{ fontSize: '14px', color: 'red', paddingLeft: "3px" }} />}</a>}

          {/* BEKI 2.0 STATUS TOGGLE */}
          {
            rowsSelectiveStatus ?
              recActive && row.showStatusSwitch ?
                <a className=""
                  style={{ cursor: `${!statusActionDisabled ? 'pointer' : ''}` }}
                  onClick={() => {
                    if (row[key] !== -1 && !statusActionDisabled)
                      this.actionClick(row, status, row[key] == active ? status.activeConfirmationMessage : status.inActiveConfirmationMessage);
                  }} >
                  {this.renderStatusImage(Number(row[key]))}
                </a>
                :
                null
              :
              recActive && showSwitch &&
              <a className=""
                style={{ cursor: `${!statusActionDisabled ? 'pointer' : ''}` }}
                onClick={() => {
                  if (row[key] !== -1 && !statusActionDisabled)
                    this.actionClick(row, status, row[key] == active ? status.activeConfirmationMessage : status.inActiveConfirmationMessage);
                }} >
                {this.renderStatusImage(Number(row[key]))}
              </a>
          }

          {
            this.props.pdfPath ?
              row.pdfPath == "0" ?
                //  <span>
                //   {/* <i className='mdi mdi-onedrive' /> */}
                //   <img style={{ width: '50px' }} src={loader} />
                // </span>
                (actionCols || []).map((action, actionKey) => (
                  <button disabled href="javascript:void(0);" key={actionKey} onClick={this.actionClick.bind(this, row, action, null)} className={`btn ${action.icon === 'mdi mdi-download' ? 'text-white btn-primary' : 'btn-primary'} action-pad`}>&nbsp;
                    {action.icon && <i className={`${action.icon} ${action.icon === 'mdi mdi-download' && 'text-white'}`} />}
                    {action.text && <span>{action.text}</span>}
                  </button>)
                )
                :
                (actionCols || []).map((action, actionKey) => (
                  <a href="javascript:void(0);" key={actionKey} onClick={this.actionClick.bind(this, row, action, null)} className={`btn ${action.icon === 'mdi mdi-download' ? 'text-white btn-primary' : 'btn-primary'} action-pad`}>&nbsp;
                    {action.icon && <i className={`${action.icon} ${action.icon === 'mdi mdi-download' && 'text-white'}`} />}
                    {action.text && <span>{action.text}</span>}
                  </a>)
                )
              :
              (actionCols || []).map((action, actionKey) => {
                if (action.showOnlyIconWithToolTip) {
                  return (
                    <div class="tooltip">
                      <a href="javascript:void(0);" key={actionKey} onClick={this.actionClick.bind(this, row, action, null)} className={`toolTipIconStyle`}>&nbsp;
                        {action.icon && <i className={`${action.icon}`} />}
                      </a>
                      <span class="tooltiptext"
                        style={{
                          backgroundColor: action.toolTipColor ? action.toolTipColor : 'black',
                          color: action.toolTipTextColor ? action.toolTipTextColor : 'white'
                        }}>
                        {action.text}
                      </span>
                      <span class="triangle-down" style={{
                        width: 0,
                        height: 0,
                        borderLeft: '7px solid transparent',
                        borderRight: '7px solid transparent',
                        borderTop: `7px solid ${action.toolTipColor}`
                      }}></span>
                    </div>
                  )
                }
                else {
                  if ((!row.isErrorIconVisible && !row.isErrorPresent) && action.icon === 'mdi mdi-alert') {
                    return "";
                  }
                  else if ((!row.hasOwnProperty("isDataPresent") || row.isDataPresent == 0) && action.type == "chart") {
                    return (
                      <a href="javascript:void(0);" key={actionKey} disabled style={{ cursor: 'not-allowed', opacity: 0.2, border: 'none' }} className={`hoverBackgroundNone`}>&nbsp;
                        {action.icon && <i className={`${action.icon} ${action.icon === 'mdi mdi-pencil' && 'text-white'}`} />}
                        {action.text && <span>{action.text}</span>}
                      </a>
                    )
                  }
                  else {
                    const { isEditVisible = true, disabledActions = [], isErrorPresent } = row;
                    let disabled = disabledActions.includes(action.icon) ? true : false;

                    if (isEditVisible) {
                      return (
                        <a href="javascript:void(0);" style={{ cursor: `${!disabled ? 'pointer' : 'not-allowed'}`, opacity: `${!disabled ? '1' : '0.2'}` }} key={actionKey} title={action.title && action.title} onClick={this.actionClick.bind(this, row, action, null)} className={`${action.hide && !action.hide(row) && 'd-none'} ${action.iconType !== 'new' ? 'btn btn-primary action-pad' : ''} ${action.icon === 'mdi mdi-download' ? '' : action.icon === 'mdi mdi-alert' ? 'btn-error' : ''} ${disabled ? 'pe-none disabled' : ''} text-decoration-none`}>&nbsp;
                          {action.icon && <i className={`${action.icon} ${action.icon === 'mdi mdi-pencil' && 'text-white'}`} />}
                          {action.text && <span>{action.text}</span>}
                        </a>
                      )
                    }
                  }
                }
              }
              )
          }


          {
            !!deleteOption.length && <Popup on={'click'} trigger={<button type="button" class="btn btn-outline-primary action-pad">
              &nbsp;<i className={'mdi mdi-dots-vertical'} />
            </button>} flowing>
              {deleteOption} Delete
            </Popup>
          }

        </td >
      );
    }
  };

  // ----* handel Change Expanded value*-----
  handelChangeExpanded = (row) => {
    const { keyCol } = this.props.options;
    let { tableData, } = this.state;
    let item = tableData.find((item) => item[keyCol] === row[keyCol]);
    if (item) item.isExpanded = !item.isExpanded;
    this.setState({ tableData });
  };

  // ----* Render Expanded Icon *-----
  renderExpandedIcon = (row) => row.isExpanded ? <i style={{ color: "#303890" }} className="ti ti-circle-minus"></i> : <i style={{ color: "#303890" }} className="ti ti-circle-plus"></i>;


  renderSelectionAction = (row) => {
    const { selectedIds } = this.state;
    let { options: { unique_key } } = this.props;
    return <td>
      <input type="checkbox"
        checked={selectedIds[row[unique_key]] ? true : false}
        onChange={(e) => this.handleSelect(e, row)}
      />
    </td>;
  };

  handleSelect = (e, row) => {
    let { options: { unique_key }, selectionChange } = this.props;
    const { selectedIds } = this.state;
    selectedIds[row[unique_key]] = e.target.checked;
    this.setState({ selectedIds, selectedheader: false }, () =>
      this.checkAllChange(),
      selectionChange(this.state.selectedIds));
  };

  checkAllChange = () => {
    const { selectedIds, pagingData } = this.state;
    let { options: { unique_key } } = this.props;
    let checkAll = pagingData.every((value) => selectedIds[value[unique_key]]);
    if (checkAll) {
      this.setState({ selectedheader: true });
    }
  };

  renderMoreOptionColumn = (column, row) => {
    const { show } = this.state
    let valuesArr = column.values(row).slice(0, 2)
    return (
      <div>
        {!(show === row[column.uniqId]) && valuesArr.map((a, i) => <div key={i}>{a}</div>)}
        {show === row[column.uniqId] && column.values(row).map((a, i) => <div key={i}>{a}</div>)}
        {!(show === row[column.uniqId]) && <a href='javascript:void(0)' onClick={() => this.setState({ show: row[column.uniqId] })}>More...</a>}
      </div>
    )
  }

  // ----- * Tbody data get  * -----
  renderTbody = (options, data) => {
    const { pageIndex, pageSize } = this.state;
    const { columns, actionsThead, selection, uniqueKey } = options;
    let { expand } = this.props;
    const tbody = [];
    data.forEach((row, key) => {
      tbody.push(<tr className={`${row.isErrorPresent ? 'error' : ''} ${row.isDisabled ? 'disabledRow' : ''}`} key={key}>
        {/* {actionsThead && options.actions && options.actions.length ? this.renderActions(options, row) : ''} */}
        {selection && selection.show ? this.renderSelectionAction(row) : ''}
        {columns.map((column, columnKey) => (
          column.isDisplay !== false && <td key={columnKey} onClick={expand && column.expand && this.handelChangeExpanded.bind(this, row)}>
            {expand && column.expand && <a href="javascript:void(0);"> {
              !column.component ?
                (_.isEqual(column.name, 's.no') ?
                  ((pageSize * (pageIndex - 1)) + (key + 1)) :
                  row[column.name]) :
                column.component(row, column)} {this.renderExpandedIcon(row)}</a>
            }
            {
              !(expand && column.expand) ?
                !column.component ?
                  column.showMoreOption ?
                    this.renderMoreOptionColumn(column, row) :
                    (_.isEqual(column.name, 's.no') ?
                      ((pageSize * (pageIndex - 1)) + (key + 1)) :
                      row[column.name]) :
                  column.component(row, column) : null
            }
          </td>))}
        {actionsThead && !this.props.hideActionColumn ? this.renderActions(options, row) : ''}
      </tr>);
      if (expand && row.isExpanded) {
        tbody.push(<tr key={`${key}-${key + 1}`} className="expand-table-bg">
          {<td key={key} colSpan={columns.length}>
            {expand(row)}
          </td>}
        </tr>);
      }
    });
    return tbody;
  };


  // ----- * get Page Size in dropdown  * -----
  getPageSize = () => PAGESIZE.map((item, index) => <option key={index} value={item.value}>{item.text}</option>);

  handleSearch = ({ target: { name, value } }) => {
    // this.setState({ pageIndex: 1, [name]: value, selectedIds: {}, selectedheader: false }, () => {
    //   this.handleCommonMethods();
    // });
    this.setState({ pageIndex: 1, [name]: value }, () => {
      this.handleCommonMethods();
    });
  };

  handleDownloadCSV = (e) => {
    e.preventDefault();
    const { tableData } = this.state;
    const { handelAction, options: { columns = [], CSVDownload = {} } = {} } = this.props;
    handelAction(tableData, CSVDownload, columns);

  };

  render() {
    const { options, options: { showHeader = true } } = this.props;
    const { filterText, tableData, dataLength, pageSize, pageNeighbours, pageIndex, paging, confirmationOpen, confirmationInfo } = this.state;
    return (
      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}
        <div>
          {
            options.CSVDownload && options.CSVDownload.showCSVButton &&
            <div className="float-right csv-download p-3 m-1">
              <div className="float-right d-inline-flex">
                <button className="btn btn-primary" style={{ height: 35 }} onClick={this.handleDownloadCSV} disabled={tableData.length === 0}>
                  <i class="ti ti-cloud-download ti-xs me-2"></i>
                  {((options.CSVDownload && options.CSVDownload.buttonName) || "Download")}</button>
              </div>
            </div>
          }
          {
            options.showSearch &&
            <div className="float-right search">
              <div className="d-inline-flex pt-1">
                Search &nbsp;
              </div>
              <div className="float-right d-inline-flex mr-1">
                <input type="text" name="filterText" value={filterText} className="form-control" placeholder={options.placeholder ? options.placeholder : ''} onChange={this.handleSearch} />
              </div>
            </div>
          }

        </div>
        <div>
          <div className="table-responsive custom-generic-table">
            <table className="table table-striped table-no-bordered  data-table dataTable no-footer">

              {showHeader && <thead>
                <tr>
                  {this.renderThead(options)}
                </tr>
              </thead>}

              <tbody>
                {
                  tableData.length > 0 ? this.renderTbody(options, tableData) : <tr>
                    <td className='text-center centerImp' colSpan={options.columns.length + 1}>No Data Found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          {paging && tableData.length > 0 &&
            <div className="d-flex justify-content-between p-3">
              <div className="d-flex">
                <div className="d-flex align-items-center mr-2">
                  <label className='mb-0'>View</label>
                </div>
                <div className="d-flex align-items-center">
                  <select value={pageSize} className="row-per-page form-control" onChange={(e) => { this.handlePaging({ currentPage: 1, pageLimit: parseInt(e.target.value) }); }}>
                    {this.getPageSize()}
                  </select>
                </div>
                <div className="d-flex align-items-center ml-2">
                  <label className='mb-0'>Items per page</label>
                </div>
              </div>
              <div className="float-right">
                { /* ----- * import  Pagination  component and pass props(pageIndex || totalRecords || pageLimit || pageNeighbours || onPageChanged ) * ----- */}

                <Pagination pageIndex={pageIndex} totalRecords={dataLength} pageLimit={pageSize} pageNeighbours={pageNeighbours} onPageChanged={this.handlePaging} />
              </div>
            </div>
          }
        </div>
      </>
    );
  }
}

index.propTypes = {
  data: PropTypes.array,
  expand: PropTypes.func,
  handelAction: PropTypes.func,

  // options key PropTypes set
  options: PropTypes.shape({
    columns: PropTypes.array,
    actions: PropTypes.array,
    sortable: PropTypes.bool,
    dateType: PropTypes.bool,
    paging: PropTypes.bool,
    actionsThead: PropTypes.bool,
    keyCol: PropTypes.string,

    //  defaultSortParams type string
    defaultSortParams: PropTypes.shape({
      sort_by: PropTypes.string,
      sort_order: PropTypes.string
    }),

    // defaultPagingParams type number
    defaultPagingParams: PropTypes.shape({
      pageSize: PropTypes.number,
    })
  }),
};